var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisingEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 44,
    viewBox: "0 0 227 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iruhmvylma)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 37a1 1 0 0 1-1-1V6h2v30a1 1 0 0 1-1 1z",
    fill: "#1E7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07070F",
    fillOpacity: 0.4,
    d: "M43.984 37V6h1v31zM9.984 6a1 1 0 0 1 1-1h33a1 1 0 0 1 1 1h-35zM76.984 6a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1h-34zM142.984 6a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1h-34zM208.984 6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1h-28zM44 37h35a1 1 0 0 1-1 1H45a1 1 0 0 1-1-1zM110 37h35a1 1 0 0 1-1 1h-33a1 1 0 0 1-1-1zM176 37h35a1 1 0 0 1-1 1h-33a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M77 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07070F",
    fillOpacity: 0.4,
    d: "M109.984 37V6h1v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M143 37V6h2v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07070F",
    fillOpacity: 0.4,
    d: "M175.984 37V6h1v31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AFF",
    d: "M209 37V6h2v31zM12.06 14.94a1.5 1.5 0 0 0-2.12 0L.392 24.484a1.5 1.5 0 1 0 2.122 2.122L11 18.12l8.485 8.486a1.5 1.5 0 1 0 2.122-2.122L12.06 14.94zM9.5 16v3h3v-3h-3zM79.06 14.94a1.5 1.5 0 0 0-2.12 0l-9.547 9.545a1.5 1.5 0 1 0 2.122 2.122L78 18.12l8.485 8.486a1.5 1.5 0 1 0 2.122-2.122L79.06 14.94zM76.5 16v3h3v-3h-3zM145.061 14.94a1.501 1.501 0 0 0-2.122 0l-9.546 9.545a1.501 1.501 0 0 0 2.122 2.122L144 18.12l8.485 8.486a1.5 1.5 0 0 0 2.122-2.122l-9.546-9.546zM142.5 16v3h3v-3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.061 14.94a1.501 1.501 0 0 0-2.122 0l-9.546 9.545a1.501 1.501 0 0 0 2.122 2.122L210 18.12l8.485 8.486a1.5 1.5 0 0 0 2.122-2.122l-9.546-9.546zM208.5 16v3h3v-3h-3z",
    fill: "#1E7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iruhmvylma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h227v44H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisingEdge);
export default __webpack_public_path__ + "static/media/rising-edge.daaa2ca5.svg";
export { ForwardRef as ReactComponent };